import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MahsProps, ScesProps, VesselProps } from "@shape/reef-shared";

export interface VesselState {
  isLoadingVessels: boolean;
  isLoadingMahs: boolean;
  isLoadingSces: boolean;
  vessels: VesselProps[];
  mahs: MahsProps[];
  sces: ScesProps[];
  selectedVesselId: string;
  selectedMah: string;
  mahFilter: number | null;
  isEpsButtonActive: boolean;
}

export const vesselSlice = createSlice({
  name: "vessel",

  initialState: {
    isLoadingVessels: true,
    isLoadingMahs: false,
    isLoadingSces: false,
    vessels: [],
    mahs: [],
    sces: [],
    selectedVesselId: "",
    selectedMah: "",
    mahFilter: null,
    isEpsButtonActive: false,
  } as VesselState,

  reducers: {
    setIsLoadingVessels: (state, action) => {
      state.isLoadingVessels = action.payload;
    },
    setVessels: (state, action) => {
      state.vessels = action.payload;
    },
    setIsLoadingMahs: (state, action) => {
      state.isLoadingMahs = action.payload;
    },
    setMahs: (state, action) => {
      state.mahs = action.payload;
    },
    setIsLoadingSces: (state, action) => {
      state.isLoadingSces = action.payload;
    },
    setSces: (state, action) => {
      state.sces = action.payload;
    },
    setSelectedVesselId: (state, action) => {
      state.selectedVesselId = action.payload;
    },
    setSelectedMah: (state, action) => {
      state.selectedMah = action.payload;
    },
    setMahFilter: (state, action) => {
      state.mahFilter = action.payload;
    },
    setIsEpsButtonActive: (state, action) => {
      state.isEpsButtonActive = action.payload;
    },
  },
});

/* thunks */
const fetchVessels = createAsyncThunk(
  "vessel/fetchVessels",
  async (_country: string, { dispatch }) => {
    // Reconnect this thunk only if a confirmed v2 endpoint is available.
    dispatch(vesselSlice.actions.setIsLoadingVessels(true));
    // const { vessels } = await getVesselsPage(country);
    // dispatch(vesselSlice.actions.setVessels(vessels));
    dispatch(vesselSlice.actions.setIsLoadingVessels(false));
  },
);

export const thunks = {
  fetchVessels,
};

export const actions = {
  ...vesselSlice.actions,
};
